import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Button, Divider } from "@mui/material";
import { Typography } from "@mui/material";
import clsx from "clsx";
import CreatableSelect from "react-select/creatable";

const PREFIX = "Tags";

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  paddingRoot: `${PREFIX}-paddingRoot`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  actionButton: `${PREFIX}-actionButton`,
  marginTop: `${PREFIX}-marginTop`,
  divider: `${PREFIX}-divider`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: "100%",
    textAlign: "center",
    paddingTop: "1rem",
  },

  [`& .${classes.paddingRoot}`]: {
    padding: "1rem",
  },

  [`& .${classes.title}`]: {
    marginBottom: "0.5rem !important",
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: "1.5rem !important",
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up("sm")]: {
      width: "80%",
    },
    margin: "0 auto",
  },

  [`& .${classes.buttonContainer}`]: {
    display: "flex",
    justifyContent: "end",
    [theme.breakpoints.up("sm")]: {
      width: "90%",
    },
  },

  [`& .${classes.actionButton}`]: {
    float: "right",
  },

  [`& .${classes.marginTop}`]: {
    marginTop: "1rem",
  },

  [`& .${classes.divider}`]: {
    // marginTop: '3rem',
    // marginBottom: '2rem',
  },

  [`& .react-select__input`]: {
    color: "white !important",
  },
}));

const Tags = (props) => {
  const { t } = useTranslation();
  const [tagsInput, setTagsInput] = useState("");

  if (props.currentStep >= 8) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.paddingRoot)}>
          <Typography variant="h5" className={classes.title}>
            {t("exparienceCreateForm.tagsTitle")}
          </Typography>
          <Typography variant="body2" className={classes.subTitle}>
            {t("exparienceCreateForm.tagsSubTitle")}
          </Typography>
          <div className={classes.contentContainer}>
            <div className={clsx(classes.marginTop, classes.marginBottom)}>
              <CreatableSelect
                isClearable
                defaultValue={
                  props.exparience &&
                  props.exparience.tags &&
                  props.exparience.tags.map((item) => {
                    return {
                      value: item,
                      label: item,
                      name: item,
                    };
                  })
                }
                isMulti
                formatCreateLabel={(inputValue) =>
                  `${t("myExpariences.form.addTag")} ${inputValue}`
                }
                noOptionsMessage={() => t("account.form.noResults")}
                getOptionLabel={(option) =>
                  option.label ? option.label : option.name
                }
                placeholder={t("myExpariences.form.addTagPlaceholder")}
                onKeyDown={(e) => {
                  if (!tagsInput) return;
                  switch (e.key) {
                    case "Enter":
                      setTagsInput("");
                      break;
                    case "Tab":
                      setTagsInput("");
                      break;
                    default:
                      setTagsInput("");
                  }
                }}
                onInputChange={(value) => setTagsInput(value)}
                onChange={(newValue, actionMeta) => {
                  if (
                    actionMeta.action !== "pop-value" &&
                    actionMeta.action !== "remove-value" &&
                    actionMeta.action !== "clear"
                  ) {
                    const tmpValue = [...newValue];
                    tmpValue.forEach((item) => {
                      item.label = item.value;
                      item.name = item.value;
                    });
                    props.handleChangeField("tags", tmpValue);
                  } else {
                    props.handleChangeField("tags", newValue);
                  }
                }}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          </div>
          {props.currentStep === 8 && (
            <div className={clsx(classes.buttonContainer, classes.marginTop)}>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => props.handleNextStep(9)}
                className={classes.actionButton}
              >
                {t("exparienceCreateForm.continueButton")}
              </Button>
            </div>
          )}
        </div>
        <Divider light className={classes.divider} />
      </Root>
    );
  } else {
    return null;
  }
};

export default Tags;
